.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.label {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: var(--text-2xs);
  font-weight: var(--weight-bold);
  color: var(--color-text-muted);
  letter-spacing: 0.005em;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.optional {
  font-weight: var(--weight-medium);
  color: var(--color-text-faint);
}

.message {
  font-size: var(--text-2xs);
  line-height: var(--leading-snug);
  color: var(--color-text-faint);
}

.error {
  display: flex;
  align-items: flex-start;
  gap: var(--space-1);
  color: var(--color-danger-text);
  font-weight: var(--weight-medium);
}

.errorIcon {
  flex: none;
  width: 14px;
  height: 14px;
  margin-top: 1px;
}
